import axios from 'axios';
import {
    getAccessToken,
    isAccessTokenExpired,
    notifySessionExpired,
    refreshAccessToken,
} from './authSession';

const axiosInstance = axios.create({
    baseURL: '/api',
    withCredentials: true,
});

const isAuthEndpoint = (url = '') => url.includes('/auth/login') || url.includes('/auth/refresh');

axiosInstance.interceptors.request.use(async (config) => {
    let token = getAccessToken();
    if (token && isAccessTokenExpired(token) && !isAuthEndpoint(config.url)) {
        try {
            token = await refreshAccessToken();
        } catch (error) {
            notifySessionExpired();
            return Promise.reject(error);
        }
    }

    if (token) {
        config.headers = config.headers ?? {};
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
    response => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && originalRequest && !originalRequest._retry && !isAuthEndpoint(originalRequest.url)) {
            originalRequest._retry = true;

            try {
                const refreshedToken = await refreshAccessToken();
                originalRequest.headers = originalRequest.headers ?? {};
                originalRequest.headers.Authorization = `Bearer ${refreshedToken}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                notifySessionExpired();
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
